import styles from './Message.module.css';

// import { hideNumber } from '../../helpers/titreHelper';

function splitNumberAndText(str) {
  const match = str.match(/^(№\s*\d+)\s+(.+)$/);

  if (match) {
    return [match[1], match[2]];
  }

  return [str, ''];
}

const Message = ({ message, currentState, winId }) => {
  const isWinner = currentState === 'S3';

  const [numberName, textName] = splitNumberAndText(message.content);

  const fs = textName?.length > 38 ? '4.4rem' : '5rem';

  return (
    <div className={styles.wrapper}>
      {message && (
        <div className={styles.blockMsg}>
          <div className={styles.nameAuthorBlock}>
            <div
              className={`${styles.nameAuthor} ${
                isWinner && winId === message.id ? styles.isWinner : ''
              }`}
            >
              {numberName && (
                <span className={styles.numberName}>{numberName} </span>
              )}
              {textName && (
                <span className={styles.textName} style={{ fontSize: fs }}>
                  {textName}
                </span>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Message;
